import * as THREE from 'three';

/**
 * Scales the object so its longest dimension equals `targetSize`,
 * then repositions it so it sits on y = 0 and is centred on x/z.
 */
export function centerAndScale(
  object: THREE.Object3D,
  targetSize = 2.5
): void {
  const box = new THREE.Box3().setFromObject(object);
  const size = box.getSize(new THREE.Vector3());
  const maxDim = Math.max(size.x, size.y, size.z);

  if (maxDim === 0) return; // guard against empty objects

  const scale = targetSize / maxDim;
  object.scale.setScalar(scale);

  // Recompute bounding box after scaling
  const scaledBox = new THREE.Box3().setFromObject(object);
  const center = scaledBox.getCenter(new THREE.Vector3());

  object.position.x -= center.x;
  object.position.y -= scaledBox.min.y; // sit on ground plane (y = 0)
  object.position.z -= center.z;
}

/**
 * Applies a hex colour string to every MeshStandardMaterial / MeshPhongMaterial
 * in the object hierarchy.
 *
 * Materials that don't expose a `.color` property are left unchanged.
 */
export function applyColorToModel(object: THREE.Object3D, hex: string): void {
  const color = new THREE.Color(hex);

  object.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) return;

    const materials = Array.isArray(child.material)
      ? child.material
      : [child.material];

    materials.forEach((mat) => {
      if ('color' in mat) {
        (mat as THREE.MeshStandardMaterial).color.set(color);
      }
    });
  });
}
